import React, { FC } from 'react';
import { ContextMenu, DropdownMenuItem } from '@erecruit/ui-kit';
import { PositionSection } from '../types';
import { MatchRecordSection } from '../../MatchRecord/types';

type SectionContextType = PositionSection | MatchRecordSection;

export interface SectionContextMenuProps<T> {
  onEdit(section: T): void;
  section: T;
}

const SectionContextMenu: FC<SectionContextMenuProps<
  SectionContextType
>> = props => {
  const { onEdit, section } = props;

  const contextMenuItems: DropdownMenuItem[] = [
    { icon: 'edit', text: 'Edit', onClick: () => onEdit(section) }, // TODO: localization
  ];

  return <ContextMenu items={contextMenuItems} />;
};

export default SectionContextMenu;
